import React from 'react';

import {
  AudioPlayerWithContext,
  AudioPlayerWithContextProps,
} from './audio-player-with-context';
import { SoundProvider } from '../../hooks/use-sound-context';

export interface AudioPlayerWithProviderProps
  extends AudioPlayerWithContextProps {
  url: string;
}

export function AudioPlayerWithProvider({
  url,
  ...props
}: AudioPlayerWithProviderProps) {
  return (
    <SoundProvider {...{ url }}>
      <AudioPlayerWithContext {...props} />
    </SoundProvider>
  );
}
